import cn from 'classnames';
import type React from 'react';
import * as st from './styles.module.scss';

interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  isActive: boolean;
  children?: React.ReactNode;
  needHover?: boolean;
}

export const Tab: React.FC<Props> = ({ isActive, children, needHover, className, ...props }) => {
  return (
    <button
      className={cn(st.tab, isActive && st.active, needHover && st.hover, className)}
      {...props}
    >
      {children}
    </button>
  );
};
